import React, { useState, useEffect } from "react"
import { Form } from "antd"

import CustomInput from "../../../v2-components/Antd/Input"
import CustomSelect from "../../../v2-components/Antd/Select"
import CustomButton from "../../../v2-components/Antd/Button"

import "../styles/common.css"
import "../styles/forms.css"
import "../styles/button.css"

const UserForm = ({ values = {}, onFinish, loading = false }) => {
    const [form] = Form.useForm()
    const [isEditing, setIsEditing] = useState(false)

    // Actualizar formulario cuando cambian los valores
    useEffect(() => {
        form.setFieldsValue(values)
    }, [values, form])

    // Manejar envío del formulario
    const handleFinish = (updatedValues) => {
        onFinish(updatedValues)
        setIsEditing(false)
    }

    // Activar modo edición
    const handleEdit = () => {
        setIsEditing(true)
    }

    // Cancelar edición
    const handleCancel = () => {
        setIsEditing(false)
        form.setFieldsValue(values)
    }

    return (
        <div className="page-container">
            <Form form={form} layout="vertical" onFinish={handleFinish} className="form-container">
                <h2 className="section-title">Datos</h2>

                {/* Correo electrónico */}
                <Form.Item
                    label="Correo electrónico"
                    name="email"
                    rules={[{ required: true, message: "Por favor ingresa un correo electrónico válido" }]}
                    className="form-item"
                >
                    <CustomInput disabled={true} />
                </Form.Item>

                {/* Primer nombre */}
                <Form.Item
                    label="Nombre del usuario"
                    name="first_name"
                    rules={[{ required: true, message: "Por favor ingresa el nombre de usuario" }]}
                    className="form-item"
                >
                    <CustomInput disabled={!isEditing} placeholder="Nombre" />
                </Form.Item>

                {/* Apellido */}
                <Form.Item
                    label="Apellido del usuario"
                    name="last_name"
                    rules={[{ required: true, message: "Por favor ingresa el apellido" }]}
                    className="form-item"
                >
                    <CustomInput disabled={!isEditing} placeholder="Apellido" />
                </Form.Item>

                {/* Solo mostrar sección de contraseña en modo edición */}
                {isEditing && (
                    <>
                        <h2 className="section-title">Cambio de contraseña</h2>

                        {/* Contraseña */}
                        <Form.Item
                            label="Contraseña"
                            name="old_password"
                            rules={[{ min: 8, message: "Debe tener al menos 8 caracteres" }]}
                            className="form-item"
                        >
                            <CustomInput.Password placeholder="Contraseña actual" />
                        </Form.Item>

                        {/* Nueva Contraseña */}
                        <Form.Item
                            label="Nueva Contraseña"
                            name="new_password"
                            rules={[{ min: 8, message: "Debe tener al menos 8 caracteres" }]}
                            className="form-item"
                        >
                            <CustomInput.Password placeholder="Contraseña nueva" />
                        </Form.Item>
                    </>
                )}

                <h2 className="section-title">Rol</h2>

                {/* Roles - Cambiado a selección única */}
                <Form.Item
                    label="Rol de usuario"
                    name="roles"
                    rules={[{ required: false, message: "Por favor selecciona un rol" }]}
                    className="form-item"
                >
                    <CustomSelect
                        placeholder="Selecciona un rol"
                        disabled={true}
                        // Si roles es un array, tomamos el primer valor
                        value={Array.isArray(values.roles) ? values.roles[0] : values.roles}
                    >
                        {Array.isArray(values.roles)
                            ? values.roles.map((role) => (
                                <CustomSelect.Option key={role} value={role}>
                                    {role}
                                </CustomSelect.Option>
                            ))
                            : values.roles && (
                                <CustomSelect.Option key={values.roles} value={values.roles}>
                                    {values.roles}
                                </CustomSelect.Option>
                            )}
                    </CustomSelect>
                </Form.Item>

                <h2 className="section-title">Sucursal</h2>

                {/* Sucursales - Cambiado a selección única */}
                <Form.Item
                    label="Sucursal"
                    name="pharmacy"
                    rules={[{ required: false, message: "Por favor selecciona una sucursal" }]}
                    className="form-item"
                >
                    <CustomSelect
                        placeholder="Selecciona una sucursal"
                        disabled={true}
                        value={"Todas las farmacias"}
                    >
                        <CustomSelect.Option>
                            Todas las farmacias
                        </CustomSelect.Option>
                    </CustomSelect>
                </Form.Item>

                {/* Botones de acción */}
                <div className="button-container">
                    {!isEditing ? (
                        <CustomButton className="plain-button" type="primary" onClick={handleEdit} disabled={loading}>
                            Editar
                        </CustomButton>
                    ) : (
                        <>
                            <CustomButton className="plain-button" type="default" onClick={handleCancel} disabled={loading}>
                                Cancelar
                            </CustomButton>
                            <CustomButton
                                className="filled-button"
                                type="primary"
                                onClick={() => form.submit()}
                                loading={loading}
                                disabled={loading}
                            >
                                Guardar
                            </CustomButton>
                        </>
                    )}
                </div>
            </Form>
        </div>
    )
}

export default React.memo(UserForm)

